import { combineReducers, createReducer } from '@reduxjs/toolkit';
import { switchAccountSuccess } from 'store/account/actions';
import { createFetchReducer } from 'store/setLocalStore';
import * as actionConstants from 'store/testResults/actions.constants';
import { imagingDetailsDownloadsReducer, shareImagingResultsReducer } from './imaging/reducers';
import {
  labDetailsDownloadsReducer,
  labHistoricalReducer,
  patientLetterDownloadsReducer,
  shareLabResultsReducer
} from './lab/reducers';
import {
  microbiologyDetailsDownloadsReducer,
  microbiologyHistoricalReducer,
  shareMicrobiologyResultsReducer
} from './microbiology/reducers';
import {
  pathologyDetailsDownloadsReducer,
  sharePathologyResultsReducer
} from './pathology/reducers';
import { testResultsListSlice } from './reducers.slice';
import { TestResult, TestResultDetailsState, TestResultWithDetails } from './types';

// *************************
// ** TEST RESULT DETAILS **
// *************************

export const testResultDetailsInitialState = (): TestResultDetailsState => ({
  isFetching: false,
  data: null,
  error: null
});

export const testResultDetailsReducer = createReducer(testResultDetailsInitialState(), {
  [actionConstants.GET_TEST_RESULT_DETAILS]: state => {
    state.isFetching = true;
    state.error = null;
  },
  [actionConstants.GET_TEST_RESULT_DETAILS_FAIL]: (state, action) => {
    state.isFetching = false;
    state.error = action.error;
  },
  [actionConstants.GET_TEST_RESULT_DETAILS_SUCCESS]: (state, action) => {
    const { data, headers } = action.payload;
    const contentType = data.contentType || headers['content-type'];

    const result = {
      contentType,
      content: action.payload.data
    };

    state.isFetching = false;
    state.data = result;
  },
  [actionConstants.RESET_TEST_RESULT_DETAILS]: () => testResultDetailsInitialState(),
  [switchAccountSuccess.type]: () => testResultDetailsInitialState()
});

export default combineReducers({
  testResultsList: testResultsListSlice.reducer,
  testResultDetails: testResultDetailsReducer,
  testResultListByEncounter: createFetchReducer<TestResult[]>(
    actionConstants.GET_TEST_RESULT_LIST_BY_ENCOUNTER
  ),
  testResultWithDetails: createFetchReducer<TestResultWithDetails>(
    actionConstants.GET_LAB_WITH_DETAILS
  ),
  labHistorical: labHistoricalReducer,
  shareLabResults: shareLabResultsReducer,
  shareMicrobiologyResults: shareMicrobiologyResultsReducer,
  shareImagingResults: shareImagingResultsReducer,
  sharePathologyResults: sharePathologyResultsReducer,
  microbiologyHistorical: microbiologyHistoricalReducer,
  downloadLabDetails: labDetailsDownloadsReducer,
  downloadPatientLetter: patientLetterDownloadsReducer,
  downloadMicrobiologyDetails: microbiologyDetailsDownloadsReducer,
  downloadImagingDetails: imagingDetailsDownloadsReducer,
  downloadPathologyDetails: pathologyDetailsDownloadsReducer
});
